import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import toast from 'react-hot-toast'

interface UpdateCapacityParams {
  ansibleId: string
  currentMacMinis?: number
  currentPhysicalPhones?: number
}

const updateAnsibleCapacity = async ({
  ansibleId,
  currentMacMinis,
  currentPhysicalPhones,
}: UpdateCapacityParams) => {
  const updateData: any = {}

  if (currentMacMinis !== undefined) {
    updateData.currentMacMinis = currentMacMinis
  }

  if (currentPhysicalPhones !== undefined) {
    updateData.currentPhysicalPhones = currentPhysicalPhones
  }

  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/ansibles/${ansibleId}`,
    {
      method: API_METHODS.PUT,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify(updateData),
    }
  )

  response = handleErrors(response)
  return response.json()
}

const useAnsibleCapacityUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation(updateAnsibleCapacity, {
    onError: (error: Error) => {
      console.error('Failed to update ansible capacity:', error)
      toast.error(`Failed to update ansible capacity: ${error.message}`)
    },
    onSuccess: (data, variables) => {
      // Invalidate related queries
      queryClient.invalidateQueries(['ansible-detail', variables.ansibleId])
      queryClient.invalidateQueries(['ansibles'])
      queryClient.invalidateQueries(['available-ansibles'])

      // Don't show success toast for capacity updates as it's part of a larger flow
    },
  })
}

export default useAnsibleCapacityUpdate
